// extracted by mini-css-extract-plugin
export default {"icon-class":"icon-class__Oz2Gd","tag":"tag__LXVOp","completed":"completed__+Buvj","in-progress":"in-progress__o45DL","header-text":"header-text__ggIum","card":"card__6LeHD"};